/**
 * @flow
 * @relayHash f0eb0c01372cb1a00eec4ee67a01a855
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ActivitiesAdminQueryResponse = {|
  +admin: ?{| |};
|};
*/


/*
query ActivitiesAdminQuery {
  admin {
    ...Activities_admin
  }
}

fragment Activities_admin on Admin {
  allActivities(first: 20) {
    edges {
      node {
        id
        message
        type
        title
        status
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivitiesAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Activities_admin",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ActivitiesAdminQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "ActivitiesAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 20,
                "type": "Int"
              }
            ],
            "concreteType": "ActivityConnection",
            "name": "allActivities",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ActivityEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "allActivities{\"first\":20}"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query ActivitiesAdminQuery {\n  admin {\n    ...Activities_admin\n  }\n}\n\nfragment Activities_admin on Admin {\n  allActivities(first: 20) {\n    edges {\n      node {\n        id\n        message\n        type\n        title\n        status\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/admin/__generated__/ActivitiesAdminQuery.graphql.js